/**
 * direct-cust-hams-31aug23.jira-dev.com - correct
 * https://direct-cust-hams-31aug23.atlassian.net - wrong
 * http://direct-cust-hams-31aug23.atlassian.com - wrong
 * x.com - correct
 * x1.com - correct
 * abc.com - correct
 * abc.education - correct
 * www.abc.education - wrong
 * direct-cust-hams-31aug23.atlassian.com/asdmalksdmal - wrong
 * direct-cust-hams-31aug23.atlassian.com/#klmlaskda - wrong
 * direct-cust-hams-31aug23.atlassian.com#klmlaskda - wrong
 * direct-cust-hams-31aug23.atlassian.com? - wrong
 * direct-cust-hams-31aug23.atlassian.com# - wrong
 * direct-cust-hams-31aug23.atlassian.com?klmlaskda=asdasl&maslmda=asmdlkam - wrong
 * x.y.x.com - correct
 * x.y.x.h.com - correct
 * askdmlaskmd - wrong
 * x.atlassian.com - correct
 * x.atlassian.net - correct
 * x+y.atlassian.com - wrong
 * x+y.atlassian.net - wrong
 * x%y.atlassian.net - wrong
 * abc@atlassian.net - wrong
 * x......com - correct
 * ààààà-nkjnk.atlassian.com - wrong
 * ààààà.atlassian.com - wrong
 * abc_def.atlassian.com - wrong
 * DIrect.Atlassian.com - wrong
 * -abc.com - wrong
 * +abc.com - wrong
 * abc+.com - wrong
 * abc-.com - correct
 * aasdmas.casdas.asdasda.com - correct
 * 121312.1231231.2121312 - wrong
 */
const CLOUD_SITE_PATTERN = '(?!www)^[a-z0-9][a-z0-9.-]{0,256}\\.[a-z]{2,63}$';
export const CloudSiteRegExp = new RegExp(CLOUD_SITE_PATTERN);
